import moment from "moment";

export class DatesGenerator {
    constructor() {}

    /**
     * @private
     * Constroi array de datas considerando o ano atual decremtando seu valor
     *
     * @returns {Array}
     */
    static getDates(numPeriods = 5) {
        const year = new Date().getUTCFullYear();

        const years = Array.from(
            { length: numPeriods },
            (v, i) => year - numPeriods + i + 1
        );

        const months = Array.from({ length: 12 }, (v, i) => i + 1);

        const dates = [];

        years.forEach((year) => {
            let block = false;

            months.forEach((month) => {
                if (
                    year == new Date().getUTCFullYear() &&
                    month > new Date().getUTCMonth() + 1
                )
                    block = true;

                if (!block)
                    dates.push(
                        new Date(
                            moment(`${year}-${month}`).utcOffset(0).format()
                        )
                    );
            });
        });

        return dates;
    }
}
